import { IconButton, type IconButtonProps } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { CollapseIcon } from "@src/components/ui-kit/Icon";

type CollapseAllButtonProps = Omit<
  IconButtonProps,
  "aria-label" | "onClick"
> & {
  onClick: () => void;
};

const CollapseAllButton = ({ onClick, ...props }: CollapseAllButtonProps) => (
  <IconButton
    aria-label={t`toggle all rows`}
    colorScheme="grey"
    onClick={() => onClick()}
    variant="ghost"
    {...props}
  >
    <CollapseIcon />
  </IconButton>
);

export default CollapseAllButton;
